import React from "react";
import GenericSpinner from "./GenericSpinner.jsx";

const CardOverlayLoader = () =>
  <div className="card-overlay-loader">
    <GenericSpinner loaderSize={32} />
  </div>

export default CardOverlayLoader;
